import { Box, Menu, MenuItem, Pagination, Typography } from "@mui/material";
import { bindActionCreators } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import Texts from "../../../../resources/Texts";
import { ApplicationState } from "../../../../store";
import * as AdminDocumentsStore from "../AdminDocumentsStore";

const rowsPerPageOptions: number[] = [10, 25, 50, 100];

type AdminDocumentsTablePaginationProps = AdminDocumentsStore.AdminDocumentsState &
	typeof AdminDocumentsStore.actionCreators & {};

const AdminDocumentsTablePagination: React.FC<AdminDocumentsTablePaginationProps> = ({
	documentsCount,
	rowsPerPage,
	selectedPage,
	setRowsPerPage,
	setSelectedPage,
}) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open: boolean = Boolean(anchorEl);

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number): void => {
		setSelectedPage(value);
	};

	const handleRowsPerPageChange = (value: number): void => {
		setRowsPerPage(value);

		handleClose();
	};

	const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (): void => {
		setAnchorEl(null);
	};

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			sx={{
				marginTop: "10px",
			}}
		>
			<Box
				display="flex"
				alignItems="center"
				aria-controls={open ? "rowsPerPage-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				sx={{
					cursor: "pointer",
					height: "32px",
				}}
			>
				<Typography
					variant="tableItem"
					sx={{
						color: "#9AA0AF",
					}}
				>
					{Texts.DocumentsTable.RowsPerPage}{" "}
					<Box component="span" sx={{ color: "#ffffff" }}>
						{rowsPerPage}
					</Box>
				</Typography>
			</Box>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
			>
				{rowsPerPageOptions.map((opt, index) => (
					<MenuItem key={`opt-${index}`} onClick={() => handleRowsPerPageChange(opt)}>
						{opt}
					</MenuItem>
				))}
			</Menu>

			<Pagination
				count={Math.ceil(documentsCount / rowsPerPage)}
				page={selectedPage}
				onChange={handlePageChange}
				sx={{
					".Mui-selected.MuiButtonBase-root": {
						backgroundColor: "#57607999",
					},
					".MuiButtonBase-root:hover": {
						backgroundColor: "#57607999",
					},
				}}
			/>
		</Box>
	);
};

const mapStateToProps = (state: ApplicationState) => {
	return state.adminDocuments;
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(AdminDocumentsStore.actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminDocumentsTablePagination);
